module.exports = __webpack_public_path__ + "media/application/images/svgs/align-left-e730bf307158d93bba6b17cc39944895.svg";